class SlideshowFade extends HTMLElement {
  constructor() {
    super()
    this.swiperContainer = this.querySelector('.swiper')
    this.swiperInstance = new Swiper(this.swiperContainer, {
      loop: true,
      centerInsufficientSlides: true,
      slidesPerView: 1,
      effect: 'fade',
      speed: 800,
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 2400,
        disableOnInteraction: false
      }
    })

    this.prevButton = this.querySelector('.prev')
    if (this.prevButton !== null) {
      this.prevButton.addEventListener('click', (event) => {
        this.swiperInstance.slidePrev()
      })
    }

    this.nextButton = this.querySelector('.next')
    if (this.nextButton !== null) {
      this.nextButton.addEventListener('click', (event) => {
        this.swiperInstance.slideNext()
      })
    }
    
  }
}

customElements.define('slideshow-fade', SlideshowFade)